import React, { useState } from 'react';
import { TextField, Box, Stack } from '@mui/material';
import { BsPlusCircle, BsXCircle } from 'react-icons/bs';
import { useNavigate,useParams } from 'react-router-dom';
import axios from 'axios';

const ProfessionalLanguage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    email: '',
    user_id: params.id,
    languages: ['Français'],
    certifications: [{ name: '', number: '' }],
  });

  const handleChange = (field, value, index) => {
    setFormData((prevData) => {
      const updatedField = Array.isArray(prevData[field]) ? [...prevData[field]] : value;
      if (index !== undefined && Array.isArray(prevData[field])) {
        updatedField[index] = value;
      }

      return {
        ...prevData,
        [field]: updatedField,
      };
    });
  };

  const handleAddField = (field) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: [...prevData[field], ''],
    }));
  };

  const handleRemoveField = (field, index) => {
    setFormData((prevData) => {
      const updatedField = [...prevData[field]];
      updatedField.splice(index, 1);
      return {
        ...prevData,
        [field]: updatedField,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      // Retrieve email from local storage
      const emaildata = localStorage.getItem('email');

      // Validate form fields
      /* if (formData.languages.some((language) => !language.trim())) {
        setError('veuillez entrer les langues');
        setLoading(false);
        return;
      }

      if (formData.certifications.some((certification) => !certification.name.trim() || !certification.number.trim())) {
        setError('Veuillez saisir le nom et le numéro de toutes les certifications');
        setLoading(false);
        return;
      } */

      // Create the request data object
      const requestData = {
        user_id: params.id,
        email: emaildata,
        languages: formData.languages,
        certifications: formData.certifications,
      };

      // Use Axios to make the API request
      const response = await axios.post(`${process.env.REACT_APP_API_URL}api/prouser/add-prouserlanguage`, requestData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        // Handle success, e.g., redirect or show a success message
        navigate(`/openinghours/${params.id}`); // Redirect to the next page on success
        
      } else {
        // Handle error, e.g., show an error message
        setError("Une erreur s'est produite. Veuillez réessayer plus tard.");
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='bg-[#F5F5F5] h-[85vh] flex items-center justify-center'>
      <div className='bg-[#F5F5F5] w-full py-7 3xl:py-12'>
        <div className='md:max-w-[1200px] relative w-full h-full flex items-center justify-center m-auto'>
          <div className='max-w-[700px] 3xl:max-w-[700px] w-full h-full bg-white px-5 sm:px-12 py-2 sm:py-5 3xl:p-12' style={{ boxShadow: '0px 4px 10px 1px rgba(39, 41, 91, 0.35)', borderRadius: '33px' }}>
            <div className='px-2 py-2 3xl:py-4'>
              <h1 className='text-xl sm:text-3xl xl:text-[28px] font-extrabold md:leading-[45px] mt-6 text-primary'>Vos atouts</h1>
            </div>
            <Box
              component='form'
              onSubmit={handleSubmit}
              className='mt-5 sm:mt-5 3xl:mt-12'
              sx={{
                '& .MuiInputLabel-root': { color: '#797979' },
                '& fieldset': {
                  border: '1px solid #eee',
                  borderRadius: '8px',
                  color: '#797979',
                  background: 'rgb(39 41 91 / 6%)',
                },
              }}
            >
              <div className='grid grid-cols-12 items-center mt-3 sm:mt-10'>
                <label className='col-span-12 text-base font-medium text-gray mb-2'>Langues</label>
                {formData.languages.map((language, index) => (
                  <div key={index} className={`col-span-12 sm:col-span-12 md:col-span-12 inline-flex items-center gap-2 ${index === 0 ? 'mt-3' : 'mt-8'}`}>
                    <TextField
                      label='Saisissez une langue que vous maîtrisez'
                      variant='outlined'
                      size='small'
                      className='w-full outline-secondary focus:outline-secondary'
                      value={language}
                      onChange={(e) => handleChange('languages', e.target.value, index)}
                    />
                    {index === 0 ? (
                      <BsPlusCircle className='text-3xl cursor-pointer' onClick={() => handleAddField('languages')} />
                    ) : (
                      <BsXCircle className='text-3xl cursor-pointer' onClick={() => handleRemoveField('languages', index)} />
                    )}
                  </div>
                ))}
                {/* {error && error.includes('langue') && <p style={{color:'red'}}>{error}</p>} */}
              </div>
              <div className='grid grid-cols-12 items-center mt-3 sm:mt-10'>
                <label className='col-span-12 text-base font-medium text-gray mb-2'>Certifications</label>
                {formData.certifications.map((certification, index) => (
                  <React.Fragment key={index}>
                    <div className='col-span-6 grid grid-cols-12 items-start mt-4'>
                      <div className='col-span-12 inline-flex items-center'>
                        <TextField
                          label="Nom de la certification"
                          variant="outlined"
                          size="small"
                          className='w-full outline-secondary focus:outline-secondary'
                          value={certification.name}
                          onChange={(e) => handleChange('certifications', { ...certification, name: e.target.value }, index)}
                        />
                      </div>
                    </div>
                    <div className='col-span-4 grid grid-cols-12 items-start mx-2 mt-4'>
                      <div className='col-span-12 inline-flex items-center'>
                        <TextField
                          label="N°"
                          variant="outlined"
                          size="small"
                          className='w-full outline-secondary focus:outline-secondary'
                          value={certification.number}
                          onChange={(e) => handleChange('certifications', { ...certification, number: e.target.value }, index)}
                        />
                      </div>
                     {/*  {error && error.includes('certification number') && <p className='text-red-300 mt-2' style={{color:'red'}}>{error}</p>} */}
                    </div>
                    <div className='col-span-2 grid grid-cols-12 items-start mx-2 mt-4'>
                      <div className='col-span-12 inline-flex items-center justify-end'>
                        {index === 0 ? (
                          <BsPlusCircle className='text-3xl cursor-pointer' onClick={() => handleAddField('certifications')} />
                        ) : (
                          <BsXCircle className='text-3xl cursor-pointer' onClick={() => handleRemoveField('certifications', index)} />
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                ))}
               {/*  {error && error.includes('certification') && !error.includes('certification number') && <p className='text-red-300 mt-2' style={{color:'red'}}>{error}</p>} */}
              </div>

              <Stack alignItems='end' sx={{ mt: 2 }}>
                <button
                  type='submit'
                  className='bg-primary text-lg xl:text-xl 3xl:text-2xl font-bold text-white mt-4 sm:mt-4 3xl:mt-10 px-10 py-3 3xl:h-[62px] rounded-lg transition-all duration-300 hover:bg-secondary hover:text-white'
                  disabled={loading}
                >
                  {loading ? 'En cours...' : 'Suivant'}
                </button>
              </Stack>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalLanguage;
